var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DateRangeFilterField',{attrs:{"label":_vm.$t('dateFieldFilter.label'),"max":_vm.beginDateMax,"min":_vm.beginDateMin},on:{"update:max":function($event){_vm.beginDateMax=$event},"update:min":function($event){_vm.beginDateMin=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }